import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { round } from 'utils';

const Container = styled.div`
  width: 100%;
`;

const Video = styled.iframe`
  max-width: 100%;
  height: auto;

  &:not([width]) {
    width: 100%;
  }
`;

function EmbeddedVideo({
  aspectRatio: _aspectRatio,
  height,
  src: _src,
  title,
  width,
  ...props
}) {
  const aspectRatio =
    _aspectRatio || (width && height && round(width / height, 4)) || 16 / 9;

  let src = _src;
  if (src.includes('youtube.com')) {
    src = src.replace(/\/watch\?v=|\/v\/|\/live\//, '/embed/');
  }

  return (
    <Container {...props}>
      <Video
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        height={height}
        src={src}
        title={title}
        width={width}
        style={{ aspectRatio }}
      />
    </Container>
  );
}

EmbeddedVideo.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default EmbeddedVideo;
